import { createContext } from 'react';
import type { PropertyPreviewContextValue } from '../types/property-preview.type';

/** Shared property preview state for communications descendants. */
export const PropertyPreviewContext =
  createContext<PropertyPreviewContextValue | null>(null);
